const messages = {
    year: { singular: 'y', plural: 'y', denominator: 365, inSeconds: 31536000 },
    day: { singular: 'd', plural: 'd', denominator: 24, inSeconds: 86400 },
    hour: { singular: 'h', plural: 'h', denominator: 60, inSeconds: 3600 },
    minute: { singular: 'm', plural: 'm', denominator: 60, inSeconds: 60 },
    second: { singular: 's', plural: 's', inSeconds: 1 }
}

function pluralize(value, unit) {
    if (value === 1) return messages[unit].singular;
    return messages[unit].plural;
}

function isFloat(value) {
    return value % 1 !== 0;
}

function format(value, unit) {
    return `${parseInt(value, 10)}${pluralize(parseInt(value, 10), unit)}`
}

function remainings(seconds, value, unit) {
    return isFloat(value)
        ? (seconds - parseInt(value, 10) * messages[unit].inSeconds)
        : 0
}

function getTimeFromSeconds(seconds, unit) {
    const quantity = seconds / messages[unit].inSeconds;
    const remaining = remainings(seconds, quantity, unit)
    return { quantity: parseInt(quantity), remaining };
}

export function formatDuration(_seconds) {
    // if (_seconds === 0) return 'now';
    // if (_seconds === 1) return `1 ${messages.second.singular}`;
    // if (_seconds < 60) return `${_seconds} ${messages.second.plural}`;

    if(_seconds < 60) return '<1 min'

    const message = [];

    let year = getTimeFromSeconds(_seconds, 'year')
    let day = getTimeFromSeconds(year.remaining, 'day')
    let hours = getTimeFromSeconds(day.remaining, 'hour')
    let minutes = getTimeFromSeconds(hours.remaining, 'minute')
    // let seconds = minutes.remaining

    if(_seconds < 60*60) {
        return `${minutes.quantity} min`;
    }

    if (year.quantity > 0 && message.length < 2) {
        message.push(format(year.quantity, 'year'));
    }

    if (day.quantity > 0 && message.length < 2) {
        message.push(format(day.quantity, 'day'));
    }

    if (hours.quantity > 0 && message.length < 2) {
        message.push(format(hours.quantity, 'hour'));
    }

    if (minutes.quantity > 0 && message.length < 2) {
        message.push(format(minutes.quantity, 'minute'));
    }

    // if (seconds > 0 && message.length < 2) {
    //     message.push(format(seconds, 'second'));
    // }
    return message.length > 2
        ? message.slice(0, message.length - 1).join(' ') + " " + message[message.length - 1]
        : message.join(' ');
}